export const MAGIC_LINK_TYPE = Object.freeze({
  COMPANY: "COMPANY",
  PROPERTY: "PROPERTY",
  UNIT: "UNIT",
  AGENT: "AGENT",
});
